import './search.scss';

const COMPONENT_NAME = 'search';

const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_FORM: 'search__form',
  ELEMENT_SUBMIT: 'search__submit',
  ELEMENT_FIELD: 'search__form__field',
  ELEMENT_RESET: 'search__form__reset',
  ELEMENT_INPUT: 'search__form__input',
  ELEMENT_CLOSE: 'search__close__button',
  ELEMENT_BACKDROP: 'search__backdrop',
  MODIFIER_OPEN: 'search--open',
  MODIFIER_FIELD_EMPTY: 'search__form__field--empty',
};

/**
 * version    1.0
 * class      <type> (Search)
 * classdesc  Component that manage the header search dropdown
 */
export class Search {
  constructor() {
    const self = this;

    self._vars = {
      $triggerElement: null,
      $inertElements: null,
    };

    // find elements
    self._els = {};
    self._els.body = $('body');
    self._els.block = $(`.${BEM.BLOCK}`);
    self._els.searchBar = self._els.block.find('.search__bar');
    self._els.form = self._els.block.find(`.${BEM.ELEMENT_FORM}`);
    self._els.submitButton = self._els.block.find(`.${BEM.ELEMENT_SUBMIT}`);
    self._els.field = self._els.block.find(`.${BEM.ELEMENT_FIELD}`);
    self._els.reset = self._els.block.find(`.${BEM.ELEMENT_RESET}`);
    self._els.input = self._els.block.find(`.${BEM.ELEMENT_INPUT}`);

    self._initListeners();
  }

  // PRIVATE METHODS

  _initListeners() {
    const self = this;

    $('.header__search').on('click keydown', (event) => {
      if (event.type === 'click' || (event.type === 'keydown' && (event.key === 'Enter' || event.key === ' '))) {
        // open the search dropdown
        event.preventDefault();

        // memorize current focus
        self._vars.$triggerElement = $(event.currentTarget);

        self._els.block.addClass(BEM.MODIFIER_OPEN);
        self._els.body.addClass('header-open-search');

        self._els.input.trigger('focus');

        if (event.type === 'click') {
          self._els.input.addClass('click-hide-focus');
        } else {
          self._els.input.removeClass('click-hide-focus');
        }

        self._vars.$inertElements = $('#main, #footer');
        self._vars.$inertElements.attr('aria-hidden', 'true');

        $(document).off('keydown.searchTrap').on('keydown.searchTrap', (e) => {
          // ESCAPE closing
          if (e.key === 'Escape') {
            e.preventDefault();
            self._closeSearch();
            return;
          }

          // Key trap
          if (e.key === 'Tab') {
            const $focusable = self._els.searchBar.find('button:visible, input:visible');
            const $firstEl = $focusable.first();
            const $lastEl = $focusable.last();

            if (e.shiftKey) {
              if ($(document.activeElement).is($firstEl)) {
                e.preventDefault();
                $lastEl.trigger('focus');
              }
            } else if ($(document.activeElement).is($lastEl)) {
              e.preventDefault();
              $firstEl.trigger('focus');
            }
          }
        });
      }
    });

    function keypressInput(e) {
      const searchValue = this.value;
      const code = (e.keyCode ? e.keyCode : e.which);
      if (code === 13) {
        e.preventDefault();
        const searchUrl = self._els.form.data('search-url');
        const inputText = searchValue;
        window.location.replace(searchUrl + inputText);
      }
    }

    self._els.input.bind('keypress', {}, keypressInput);

    self._els.reset.on('click', () => {
      self._els.field.addClass(BEM.MODIFIER_FIELD_EMPTY);
      self._els.input.val('').trigger('input');
    });

    $(document).on('click', `.${BEM.ELEMENT_CLOSE}, body:not(".search"):not(".header__search")`, (event) => {
      const $target = $(event.target);
      if ($target.closest('.header__search').length > 0) {
        event.stopPropagation();
      } else if (
        ($target.closest('.search').length > 0)
        && !$target.parent().is(`.${BEM.ELEMENT_CLOSE}`)
        && !$target.is(`.${BEM.ELEMENT_BACKDROP}`)
      ) {
        event.stopPropagation();
      } else {
        self._closeSearch();
      }
    });

    $(document).on('keydown', `.${BEM.ELEMENT_CLOSE}`, (event) => {
      if (!event.shiftKey && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        self._closeSearch();
      }
    });

    this._els.submitButton.on('click', (e) => {
      e.preventDefault();
      const searchUrl = self._els.form.data('search-url');
      const inputText = this._els.input.val();
      window.location.replace(searchUrl + inputText);
    });
  }

  _closeSearch() {
    const self = this;

    self._els.input.val('').trigger('input');
    self._els.block.removeClass(BEM.MODIFIER_OPEN);
    $('body').removeClass('header-open-search');

    if (self._vars.$inertElements) {
      self._vars.$inertElements.removeAttr('aria-hidden');
    }

    $(document).off('keydown.searchTrap');

    if (self._vars.$triggerElement && self._vars.$triggerElement.length > 0) {
      self._vars.$triggerElement.trigger('focus');
    }
  }

  _handleAutocompleteInput(rawValue) {
    const self = this;
    const query = rawValue.trim();
    self._els.field.toggleClass(BEM.MODIFIER_FIELD_EMPTY, query.length === 0);
  }
}
